import { Validator } from "vee-validate";
import {
  UI_CHANGE_LANGUAGE,
  OPEN_MOBILE_MENU,
  CLOSE_MOBILE_MENU
} from "./types";

export default {
  state: {
    currentLanguage: "PL",
    isMobileMenuOpen: false
  },
  mutations: {
    [UI_CHANGE_LANGUAGE](state, { payload }) {
      state.currentLanguage = payload.language;
      Validator.localize(process.env.VUE_APP_DEFAULT_LANGUAGE);
    },
    [OPEN_MOBILE_MENU](state) {
      state.isMobileMenuOpen = true;
    },
    [CLOSE_MOBILE_MENU](state) {
      state.isMobileMenuOpen = false;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/ui/store/ui.store.js